import { CompanyApi } from "@/domain";
import { MODAL_HANDLER } from "@/lib/Mantine";
import { router } from "@/main";

import { nextCargoApi } from "../../baseApi";
import { LoginDriver, LoginExped } from "./auth.types";

export const authApi = nextCargoApi.injectEndpoints({
  endpoints: (builder) => ({
    loginDriver: builder.mutation<LoginDriver["result"], LoginDriver["args"]>({
      query: (body) => ({
        url: "/auth/app/login",
        method: "POST",
        body
      }),
      onQueryStarted: async (args, { queryFulfilled, dispatch }) => {
        try {
          await queryFulfilled;
        } catch (err: any) {
          const companyItem = sessionStorage.getItem("@company");
          const company = companyItem ? (JSON.parse(companyItem) as CompanyApi) : undefined;
          const driverId = err.error?.data?.driver?.id;
          const errorStatus = err.error?.status || err.status;

          if (errorStatus === 406) {
            const isAccepted = await new Promise<boolean>((resolve) => {
              MODAL_HANDLER.transferCompany({
                driver: { id: driverId },
                company: company as CompanyApi,
                altCompany: err.error?.data?.company_a,
                queueDate: err.error?.data?.company_a?.queue?.date,
                onAccept: () => resolve(true),
                onDimiss: () => resolve(false)
              });
            });

            if (!isAccepted) return;

            const { data } = await dispatch(authApi.endpoints.loginDriver.initiate(args));

            if (!data) return;

            router.navigate({ to: "/app" });
          }
        }
      },
      extraOptions: {
        maxRetries: 0
      }
    }),
    loginExped: builder.mutation<LoginExped["result"], LoginExped["args"]>({
      query: (body) => ({
        url: "/auth/login",
        method: "POST",
        body
      })
    })
  })
});
